import { iHolidayQuoteItineraryBlock } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { daysBetweenDateStrings } from "@/utils/timezone-date-utils";

export interface iTripModeStaySummary {
  blockId: string;
  nights: number;
  name: string;
  roomType?: string;
  location?: string;
  rating?: number;
}

function extractLocationLabel(place: any): string | undefined {
  if (!place) return undefined;

  const components: any[] = place.address_components || [];
  const locality =
    components.find((c) => c.types?.includes("locality"))?.long_name ||
    components.find((c) => c.types?.includes("postal_town"))?.long_name ||
    components.find((c) =>
      c.types?.includes("administrative_area_level_2")
    )?.long_name;

  if (locality) return locality;
  if (place.vicinity) return place.vicinity;

  const address = place.formatted_address as string | undefined;
  if (!address) return undefined;
  return address.split(",")[0]?.trim();
}

export function buildTripModeStaySummaries(
  hotels: iHolidayQuoteItineraryBlock[]
): iTripModeStaySummary[] {
  return hotels
    .filter((block) => block.type === "hotel" && block.accommodationData)
    .map((block) => {
      const data = block.accommodationData!;
      const room = data.rooms?.[0];
      const nights =
        room?.checkInDate && room?.checkOutDate
          ? Math.max(
              1,
              daysBetweenDateStrings(room.checkInDate, room.checkOutDate)
            )
          : 1;

      return {
        blockId: block.id,
        nights,
        name: data.accommodationName || data.title || "Accommodation",
        roomType: room?.roomType || undefined,
        location: extractLocationLabel(data.place),
        rating:
          typeof data.place?.rating === "number"
            ? Math.round(data.place.rating)
            : undefined,
      };
    });
}

export function formatTripModeStayLine(stay: iTripModeStaySummary): string {
  const nightsLabel = `${stay.nights} night${stay.nights === 1 ? "" : "s"}`;
  const ratingLabel = stay.rating ? ` ${stay.rating}⭐` : "";
  const details = [stay.roomType, stay.location].filter(Boolean).join(", ");
  return details
    ? `${nightsLabel} at ${stay.name}${ratingLabel} – ${details}`
    : `${nightsLabel} at ${stay.name}${ratingLabel}`;
}
